import React from 'react';
import { states } from '@/constants/lifecycle';
import SimpleAccordion from '@/components/accordion/SimpleAccordion';
import FormFieldList from '@/forms/components/FormFieldList';
import formFieldType, { formFieldText } from '@/forms/helper';
import selectors from '../hooks/selectors';
import fieldComponents from '../fields';

const RequestUnknownFields = ({
  active,
  category,
  code,
  index,
  onClick,
}) => {
  const { fields, request } = selectors.useRequestUnknownFields({ category, code });
  if (fields.length === 0) {
    return null;
  }

  return (
    <SimpleAccordion active={active} headerId="request.unknown.title" index={index} onClick={onClick}>
      <FormFieldList
        category={category}
        className="aridhia-request-field-list"
        code={code}
        component={(f) => fieldComponents[formFieldType(f)]}
        fields={fields}
        saveErrors={[]}
        saveStatus={states.NONE}
        section="unknown"
        text={(f) => formFieldText(request, f, 'fields.')}
      />
    </SimpleAccordion>
  );
};

export default RequestUnknownFields;
